import PropTypes from 'prop-types';
import React, { Component } from 'react';

if (process.env.NODE_ENV !== 'test') {
  require('./Tabs.scss');
}

export default class Tabs extends Component {
  state = {
    activeTab: 0,
  };

  static defaultProps = {};

  static propTypes = {
    tabs: PropTypes.array.isRequired,
    onTabChange: PropTypes.func,
    initialSelectedTab: PropTypes.number,
  };

  componentWillMount() {
    if (this.props.initialSelectedTab) {
      this.setState({ activeTab: this.props.initialSelectedTab });
    }
  }

  setTab(tab) {
    this.setState({ activeTab: tab });

    if (this.props.onTabChange) {
      this.props.onTabChange(tab);
    }
  }

  render() {
    const { activeTab } = this.state;
    const children = React.Children.toArray(this.props.children);
    return (
      <div className="Tabs">
        <ul className="accordion-tabs-minimal">
          {this.props.tabs.map((tab, i) => {
            if (typeof tab === 'string') {
              return (
                <li className="tab-header-and-content" key={i}>
                  <button
                    onClick={() => this.setTab(i)}
                    className={
                      'tab-link ' + (i === activeTab ? 'is-active' : '')
                    }
                  >
                    {tab}
                  </button>
                </li>
              );
            } else if (React.isValidElement(tab)) {
              return (
                <li className="tab-header-and-content" key={i}>
                  {tab}
                </li>
              );
            }

            return null;
          })}
        </ul>
        <div className={'tab-content'}>{children[activeTab]}</div>
      </div>
    );
  }
}
